import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSalaryBillEnvelope = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>SalaryBillEnvelope</title>
    <path
      d="m6.57 15.999 8.92 4.955c.317.176.702.176 1.018 0L25.428 16m-1.047-6.635 3.67 2.141c.322.188.52.532.52.905v15.113c0 .579-.469 1.048-1.047 1.048H4.475c-.578 0-1.047-.47-1.047-1.048V12.41c0-.373.198-.717.52-.905l3.67-2.141"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.618 5.524c0-1.158.938-2.096 2.095-2.096h12.571c1.158 0 2.096.938 2.096 2.096v11l-8.381 4.713-8.38-4.714v-11Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 6.57v1.572m0 7.856v1.571M18.095 9.19c-1.572-1.572-4.19-1.048-4.19 1.047 0 2.619 3.666 1.048 4.19 3.143.305 1.221-.46 2.62-2.62 2.619-1.57 0-2.27-1.048-2.618-1.572"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export default SvgIcoSalaryBillEnvelope;
